import { useEffect, useMemo, useState } from "react";
import { comics } from "@/mocks/comics";
import ComicCard from "./ComicCard";
import SectionHeader from "./SectionHeader";

const statusTabs = ["全部", "连载中", "已完结"];

export default function HotSection() {
  const [keyword, setKeyword] = useState("");
  const [status, setStatus] = useState("全部");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const q = params.get("search");
    if (q) setKeyword(q);
  }, []);

  const filtered = useMemo(() => {
    let list = comics;
    if (status === "连载中") list = list.filter((c) => c.status === "连载");
    if (status === "已完结") list = list.filter((c) => c.status === "完结");
    if (keyword.trim()) {
      const k = keyword.trim();
      list = list.filter(
        (c) =>
          c.title.includes(k) ||
          c.genre.includes(k) ||
          c.tags.some((t) => t.includes(k)) ||
          c.author.includes(k),
      );
    }
    return list;
  }, [keyword, status]);

  return (
    <section id="hot" className="w-full py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="热门推荐"
          title="每日更新，热门作品抢先看"
          desc="平台每日更新热门作品，支持按连载状态筛选、关键词搜索，帮你第一时间发现正在火热连载与新鲜完结的高分佳作。"
        />

        <div className="mb-8 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex flex-wrap items-center gap-2">
            {statusTabs.map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => setStatus(tab)}
                className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                  status === tab
                    ? "bg-accent-500 text-white"
                    : "bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
                aria-pressed={status === tab}
              >
                {tab}
              </button>
            ))}
          </div>
          <div className="flex items-center gap-2 rounded-full bg-background-100 px-1.5 py-1.5">
            <i className="ri-search-line pl-3 text-lg text-foreground-400" aria-hidden="true" />
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="在热门推荐中搜索…"
              aria-label="在热门推荐中搜索漫画"
              className="h-9 w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400 lg:w-56"
            />
            {keyword && (
              <button
                type="button"
                onClick={() => setKeyword("")}
                aria-label="清空搜索"
                className="flex h-8 w-8 items-center justify-center rounded-full text-foreground-500 hover:bg-background-200"
              >
                <i className="ri-close-line" aria-hidden="true" />
              </button>
            )}
          </div>
        </div>

        {filtered.length === 0 ? (
          <div className="flex flex-col items-center justify-center rounded-xl bg-background-100 py-16 text-center">
            <i className="ri-inbox-2-line text-4xl text-foreground-300" aria-hidden="true" />
            <p className="mt-3 text-sm text-foreground-600">没有找到匹配"{keyword}"的漫画，换个关键词试试吧</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
            {filtered.map((comic) => (
              <ComicCard key={comic.id} comic={comic} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}